<template>
  <v-content>
    <v-container fluid>
      <v-layout row wrap align-center justify-center>
        <v-flex xs6>
          <transition name="fadeFast">
            <v-alert
              v-model="error.show"
              color="error"
              icon="warning"
              dismissible
              centered
            >
              {{ error.message }}
            </v-alert>
          </transition>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center justify-center>
        <v-flex d-flex xs6>
          <transition name="fadeFast">
            <v-card class="elevation-12" v-show="form.show">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Email megerősítés</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    prepend-icon="person"
                    name="login"
                    label="e-Egyetem rendszerben használt e-mail cím"
                    type="text"
                    v-model="form.email"
                  ></v-text-field>
                  <v-text-field
                    id="password"
                    prepend-icon="lock"
                    name="password"
                    label="Új jelszó"
                    type="password"
                    v-model="form.password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="$router.push({ name: 'main' })">
                  <v-icon left dark>keyboard_arrow_left</v-icon>
                  Vissza
                </v-btn>
                <v-btn color="primary" @click="verification">
                  Megerősítés
                  <v-icon right dark>input</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </transition>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center justify-center>
        <v-flex xs6 text-xs-center>
          <transition name="fadeFast">
            <v-card
              v-show="!form.show"
              dark
              class="mb-2 pb-2 pm-2"
              color="success"
            >
              <h1 class="pt-3">
                Sikeres fiók megerősítés!
              </h1>
              <br />
              <v-icon x-large center dark class="mb-3"
                >check_circle_outline</v-icon
              >
              <v-spacer></v-spacer>
              <v-btn
                dark
                color="success"
                @click="$router.push({ name: 'login' })"
                class="mb-2"
              >
                Tovább a bejelentkezéshez
                <v-icon right dark>keyboard_arrow_right</v-icon>
              </v-btn>
            </v-card>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import axios from 'axios';

export default {
  data: () => ({
    drawer: null,
    form: {
      email: '',
      password: '',
      show: true
    },
    error: {
      show: false,
      code: '',
      message: ''
    }
  }),
  methods: {
    verification() {
      axios
        .post(this.$store.getters.getApiUrl + '/api/verification', {
          email: this.$data.form.email,
          password: this.$data.form.password
        })
        .then(response => {
          this.$data.form.show = false;
          //this.$router.push({path: '/home'});
        })
        .catch(error => {
          this.$data.error.message = error.response.data.message;
          this.$data.error.code = error.response.data.code;
          this.$data.error.show = true;
          // this.$store.commit("loginFailed", {error});
        });
    }
  }
};
</script>
